import type { IApiStore } from '../../../../models/ecommerce/store/storeModel';

import hybrisAxiosClient from '../clients/hybrisAxiosClient';

const fetchStoreById = async (storeId: string): Promise<IApiStore> => {
    const response = await hybrisAxiosClient.get(`/store/detailed?id=${storeId}`);
    return response.data;
};

export const storeApi = {
    fetchStoreById,
};
